const womendata=[
    {
        id:1,
        category:"Top",
        img:"https://img.freepik.com/free-photo/beautiful-smiling-model-with-horns-hairstyle-dressed-summer-hipster-jacket-jeans-clothes-sexy-carefree-girl-posing-street-trendy-funny-positive-woman-having-fun-sunglasses_158538-6670.jpg",
        price:80
       
    },
    
    
    {
        id:2,
        category:"Kurti",
        img:"https://navbharattimes.indiatimes.com/thumb/98903262/long-women-kurti-set-98903262.jpg?imgsize=180104&width=1600&height=900&resizemode=75",
       price:70.85
    },
    {
        id:3,
        category:"Tshirt",
       img:"https://www.instyle.com/thmb/2N1mmqPYHQOzsKKSS851xhPxzMQ=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/IMG_6376-bfd35d18a52447d98c3e98ab955f19f2.JPG",
       price:99.89
    },
    {
        id:4,
        category:"Top",
       img:"https://plus.unsplash.com/premium_photo-1680111699827-8606fbae4216?fm=jpg&w=3000&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fHdvbWVuJTIwdG9wfGVufDB8fDB8fHww",
       price:70.41
    },
    {
        id:5,
        category:"Kurti",
       img:"https://images.herzindagi.info/image/2023/May/fab-india-kurtis.jpg",
       price:"90.99"
    },
    {
        id:6,
        category:"Top",
       img:"https://netstorage-briefly.akamaized.net/images/e1072b7c8ab54168.jpg?imwidth=900",
       price:90.89
    },
    {
    id:7,
    category:"Kurti",
    img:"https://i.ytimg.com/vi/RjwxcrOeHnU/maxresdefault.jpg",
    price:70.99
    },
    {
        id:8,
        category:"Tshirt",
       img:"https://static.independent.co.uk/2022/02/14/17/Womens%20white%20T-shirts%20copy-2.jpg",
       price:80.77
    }
    ]
    export default womendata